import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Paper, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import DisplayResources from '../crud/DisplayResources';
import { resourceFields } from '../../data/Constants';
import { commonResourceStyle } from '../../css/style';
import LoadingBar from '../share/LoadingBar';
import CraverBreadCrumb from '../share/CraverBreadCrumb';

const styles = commonResourceStyle();

class Company extends Component {
  componentDidMount() {
    const {
      loading, companies, apiToken, actions,
    } = this.props;

    if (loading === false && !companies) {
      actions.getAllResources(apiToken, 'companies');
    }
  }

  render() {
    const {
      companies, actions, loading, apiToken, match,
    } = this.props;
    const { resource } = match.params;
    const optionsButton = [{ id: 1, btnTitle: 'view' }];
    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>Companies</Typography>
              </div>
              <div style={styles.breadcrumbContainer}>
                <CraverBreadCrumb resource={resource} />
              </div>
            </div>
            <Paper style={styles.paper}>
              <DisplayResources
                data={companies}
                actions={actions}
                fieldNames={resourceFields.companies}
                resourceName="companies"
                apiToken={apiToken}
                buttonArray={optionsButton}
              />
            </Paper>
          </div>
        )
    );
  }
}

Company.propTypes = {
  loading: PropTypes.bool.isRequired,
  companies: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
};

Company.defaultProps = {
  companies: null,
};

export default withRouter(Company);
